// extracted by mini-css-extract-plugin
export var fadeInOut = "_z-3";
export var icon = "_z-4";
export var savedIndicator = "_z-2";
export var savingIndicator = "_z-0";
export var spin = "_z-1";